/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import dayjs from "dayjs";
import styles from './SubscriptionList.module.scss';
import {Button, Input, Table, TableColumnsType} from "antd";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import subscriptionAPI from "../../api/subscriptionAPI";
import {
	SubscriptionHistoryTable,
	SubscriptionTable
} from "../UserList/UserListPanel/SubscriptionTab/SubscriptionTab.interface";

const SubscriptionList = () => {
	const [originalOrderId, setOriginalOrderId] = useState('');
	const [email, setEmail] = useState('');
	const [user, setUser] = useState<any[]>([]);
	const [subscription, setSubscription] = useState<any[]>([]);
	const [subscriptionHistory, setSubscriptionHistory] = useState<any[]>([]);

	const fetchDataByOriginalOrderId = async () => {
		if (!originalOrderId) return;
		const res = await subscriptionAPI.fetchSubscriptionAPI({originalOrderId});
		setUser(res.user ? [res.user] : []);
		setSubscription(res.subscription ? [res.subscription] : []);
		setSubscriptionHistory(res.subscriptionHistory);
	};

	const fetchDataByEmail = async () => {
		if (!email) return;
		const res = await subscriptionAPI.fetchSubscriptionAPI({email});
		setUser(res.user ? [res.user] : []);
		setSubscription(res.subscription);
		setSubscriptionHistory(res.subscriptionHistory);
	};

	const userColumns: TableColumnsType<any> = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
			width: 120,
			align: 'center',
		},
		{
			title: '이름',
			dataIndex: 'name',
			key: 'name',
			width: 80,
			align: 'center',
		},
		{
			title: '이메일',
			dataIndex: 'email',
			key: 'email',
			width: 80,
			align: 'center',
		},
		{
			title: '전화번호',
			dataIndex: 'phoneNum',
			key: 'phoneNum',
			width: 80,
			align: 'center',
		},
	];

	const subscriptionColumns: TableColumnsType<SubscriptionTable> = [
		{
			title: 'create date',
			dataIndex: 'createDate',
			key: 'createDate',
			width: 120,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),		},
		{
			title: '구글/애플',
			dataIndex: 'providerId',
			key: 'providerId',
			width: 80,
			align: 'center',
		},
		{
			title: 'original order id',
			dataIndex: 'originalOrderId',
			key: 'originalOrderId',
			width: 170,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontVariantNumeric: 'tabular-nums' }}>{value}</div>,
		},
		{
			title: 'order id',
			dataIndex: 'orderId',
			key: 'orderId',
			width: 170,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontVariantNumeric: 'tabular-nums' }}>{value}</div>,
		},
		{
			title: '상태',
			dataIndex: 'status',
			key: 'status',
			width: 30,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left' }}>{value}</div>,
		},
		{
			title: '시작일',
			dataIndex: 'startDate',
			key: 'startDate',
			width: 120,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),		},
		{
			title: '만료일',
			dataIndex: 'expireDate',
			key: 'expireDate',
			width: 120,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),		},
	];

	const subscriptionHistoryColumns: TableColumnsType<SubscriptionHistoryTable> = [
		{
			title: 'create date',
			dataIndex: 'createDate',
			key: 'createDate',
			width: 140,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),
		},
		{
			title: '구글/애플',
			dataIndex: 'providerId',
			key: 'providerId',
			width: 60,
			align: 'center',
		},
		{
			title: 'original order id',
			dataIndex: 'originalOrderId',
			key: 'originalOrderId',
			width: 150,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontVariantNumeric: 'tabular-nums', fontSize: '11px' }}>{value}</div>,
		},
		{
			title: 'order id',
			dataIndex: 'orderId',
			key: 'orderId',
			width: 150,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontVariantNumeric: 'tabular-nums', fontSize: '10px' }}>{value}</div>,
		},
		{
			title: '이벤트 유형',
			dataIndex: 'eventType',
			key: 'eventType',
			width: 20,
			align: 'center',
			render: (value) => <div style={{ textAlign: 'left', fontSize: '11px' }}>{value}</div>,
		},
		{
			title: '시작일',
			dataIndex: 'startDate',
			key: 'startDate',
			width: 140,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),
		},
		{
			title: '만료일',
			dataIndex: 'expireDate',
			key: 'expireDate',
			width: 140,
			align: 'center',
			render: (value: any) => (
				<div style={{ fontVariantNumeric: 'tabular-nums' }}>
					{dayjs(value).tz('Asia/Seoul').format('YYYY-MM-DD')} {dayjs(value).format('HH:mm')}
				</div>
			),
		},
	];

	return (
		<div className={styles.wrap}>
			{/* 타이틀 */}
			<PageTitle title="구독 조회"/>

			<div className={styles.searchWrap}>
				<div style={{ width: '300px' }}>
					<Input
						placeholder="original order id"
						value={originalOrderId}
						onChange={(e) => setOriginalOrderId(e.target.value)}
					/>
				</div>

				<Button type="primary" onClick={fetchDataByOriginalOrderId}>
					검색
				</Button>

				<div style={{ width: '300px' }}>
					<Input
						placeholder="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
				</div>

				<Button type="primary" onClick={fetchDataByEmail}>
					검색
				</Button>
			</div>


			{subscription?.length > 0 && (
				<div style={{ marginTop: '20px' }}>
					{/* User */}
					<Table
						title={() => <div>User</div>}
						bordered
						columns={userColumns}
						dataSource={user}
						rowKey="id"
						size="small"
						scroll={{ x: 'max-content' }}
						pagination={false}
						key="user"
					/>

					<div style={{ marginTop: '20px' }} />

					{/* Subscription */}
					<Table
						title={() => <div>Subscription</div>}
						bordered
						columns={subscriptionColumns}
						dataSource={subscription}
						rowKey="id"
						size="small"
						scroll={{ x: 'max-content' }}
						pagination={false}
					/>

					<div style={{ marginTop: '20px' }} />

					{/* Subscription History */}
					<Table
						title={() => <div>Subscription History</div>}
						bordered
						columns={subscriptionHistoryColumns}
						dataSource={subscriptionHistory}
						rowKey="id"
						size="small"
						scroll={{ x: 'max-content' }}
						pagination={false}

					/>
				</div>
			)}
		</div>
	);
};

export default SubscriptionList;
